// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ji-0";
export var animationContainer = "_ji-1";
export var itemPrice = "_ji-a";
export var itemizedContent = "_ji-9";
export var itemizedHeader = "_ji-7";
export var itemizedRow = "_ji-8";
export var itemizedSection = "_ji-6";
export var modalContent = "_ji-2";
export var orderName = "_ji-3";
export var refundOption = "_ji-4";
export var refundOptionsContainer = "_ji-5";
export var shippingLabel = "_ji-b";
export var totalRow = "_ji-c";